import { ActionIcon, Box, Button, Container, Flex, Switch, Text, Tooltip } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconEdit, IconPlus, IconTrash, IconUserPlus,IconMap  } from "@tabler/icons";
import AppBreadcrumb from "components/AppBreadcrumb";
import AppPageHeader from "components/AppPageHeader";
import FloatingMenu from "components/FloatingMenu";
import produce from "immer";
import { MantineReactTable } from "mantine-react-table";
import { hasPermission } from "pages/Auth/permissionGuard";
import { useMemo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { showErrorToast, showSuccessToast } from "utilities/Toast";
import { openDeleteConfirmation } from "utilities/utility";

import AddCounterModal from "./AddCounterModal";
import CounterUsersModal from "./CounterUsersModal";
import { counters_api } from "./counter.service";
import { Modal, Select, TextInput } from "@mantine/core";

export default function CountersList() {
  const queryClient = useQueryClient();
  let isMobileScreen = useMediaQuery("(max-width: 768px)");

  const [selectedCounter, setSelectedCounter] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const [addCounterModalVisible, setAddCounterModalVisible] = useState(false);
  const [assignUsersModalVisible, setAssignUsersModalVisible] = useState(false);

  const [countersList, setCountersList] = useState([]);

  const [showAreaTable, setShowAreaTable] = useState(false);
  const [areaList, setAreaList] = useState([]);
  const [areaModalVisible, setAreaModalVisible] = useState(false);
  const [areaId, setAreaId] = useState(null);
  const [counterId, setCounterId] = useState("");
  const [area, setArea] = useState("");
  const [town, setTown] = useState("");

  const [cityId, setCityId] = useState("");
  const [cityName, setCityName] = useState("");
  const [cityList, setCityList] = useState([]);
  


  const get_cities = useQuery({
  queryKey: ["cities"],
  queryFn: counters_api.get_cities,
  onSuccess: (data) => {

    const flat = data.data.flatMap(e => e.city);

    const cities = flat.map(e => ({
      label: e.city,
      value: e.id,
    }));

    setCityList(cities); // ✅ IMPORTANT

    console.log("cityList:", cities);
  },
});

  const counter_data = useQuery({
    queryKey: ["counters-data"],
    queryFn: () => counters_api.get(),
    onSuccess: data => {
      setCountersList(data.data);
    },
  });

  const loadAreas = async () => {

  const res = await counters_api.get_counter_areas();

  if (res.success) {
    setAreaList(res.data);
  }

};

const saveArea = async () => {

  const payload = {
    id: areaId,
    counter_id: counterId,
    area: area,
    city_id: cityId
  };

  let res;

  if (areaId) {
    res = await counters_api.edit_counter_area(payload);
  } else {
    res = await counters_api.add_counter_area(payload);
  }

  if (res.success) {

    showSuccessToast({
      title: "Success",
      message: areaId ? "Area updated" : "Area added"
    });

    setAreaModalVisible(false);

    setArea("");
    setCityId("");
    setCityName("");
    setCounterId("");
    setAreaId(null);

    loadAreas();

  }

};

const handleEditArea = (data) => {

  setAreaId(data.id);
  setCounterId(data.counter_id.toString());
  setArea(data.area);
  setCityId(data.city_id);
  setCityName(data.city_name);

  setAreaModalVisible(true);

};

const deleteArea = async (id) => {

  const res = await counters_api.delete_counter_area(id);

  if (res.success) {

    showSuccessToast({
      title: "Success",
      message: "Area deleted"
    });

    loadAreas();

  }

};



  const columns = useMemo(
    () => [
      {
        header: "Counter Name",
        accessorKey: "name",
        Cell: ({ cell }) => <Text tt={"capitalize"}>{cell.getValue()}</Text>,
        size: "auto",
      },
      {
        header: "Contact Person",
        accessorKey: "contact_person",
        Cell: ({ cell }) => <Text tt={"capitalize"}>{cell.getValue()}</Text>,
        size: "auto",
      },
      {
        header: "Contact Number",
        accessorKey: "contact_number",
        Cell: ({ cell }) => <Text tt={"capitalize"}>{cell.getValue()}</Text>,
        size: "auto",
      },
      {
        header: "Active",
        accessorKey: "active",
        size: "auto",
        Cell: ({ cell, row }) => (
          <Switch
            onChange={e => handleStatusChange(row.original.id, e.target.checked)}
            checked={cell.getValue()}
            size={"xs"}
          />
        ),
      },
    ],
    []
  );
  

  
  const handleRemoveCounter = id => {
    openDeleteConfirmation("Counter", () => {
      deleteCounter.mutate({
        users: [id],
      });
    });
  };

  const deleteCounter = useMutation({
    mutationFn: data => counters_api.unassign_users(data),
    onSuccess: data => {
      console.log(data);
      showSuccessToast({
        title: "Success",
        message: "Deleted Counter.",
      });
      queryClient.invalidateQueries(["counters-data"], ["counters-users"]);
    },
    onError: () => {
      showErrorToast({
        title: "Error",
        message: "Error deleting counter.",
      });
    },
  });

  const changeStatus = (id, status) => {
    setCountersList(
      produce(draft => {
        let item = draft.find(e => e.id === id);
        item.active = status;
      })
    );
  };

  const handleStatusChange = async (id, status) => {
    await counters_api
      .changeStatus({
        id: id,
        active: status,
      })
      .then(res => {
        console.log("res", res);
        if (res.data.success) {
          changeStatus(id, status);
        } else {
          showErrorToast({ title: "Error", message: res.message });
        }
      });
  };

  const handleEdit = data => {
    setSelectedCounter(data);
    setIsEditing(true);
    setAddCounterModalVisible(true);
  };

  return (
    <>
      <Container fluid p={isMobileScreen ? 5 : 25}>
        {isMobileScreen ? (
          <></>
        ) : (
           !showAreaTable && (
          <AppPageHeader
  title="Counters"
  button={
    hasPermission("add_counter") &&(
      <Flex>

        <Button
          onClick={() => {
            setAddCounterModalVisible(true);
          }}
        >
          <IconPlus style={{ width: "20px" }} />
          <Text ml={10}> Add Counter </Text>
        </Button>

        <Button
          ml={10}
          onClick={() => {
            setShowAreaTable(true);
            loadAreas();
          }}
        >
          <IconMap  style={{ width: "20px" }} />
          <Text ml={10}> Area </Text>
        </Button>

      </Flex>
    )
  }
/>
       ) )}</Container>
      <Container fluid mt={10} mb={30}>
        <Box px={isMobileScreen ? 5 : 25} sx={{ borderRadius: 2 }}>
         <Box className="datatable-wrapper">

{showAreaTable ? (

<>
 <AppPageHeader
  title="Area List"
  button={
    <Flex>
      <Button
        mr={10}
        onClick={() => setShowAreaTable(false)}
      >
        Back
      </Button>

      <Button
        onClick={() => setAreaModalVisible(true)}
      >
        <IconPlus style={{ width: 20 }} />
        <Text ml={10}> Add Area </Text>
      </Button>
    </Flex>
  }
/>

  <MantineReactTable
    columns={[
      {
        header: "Counter",
        accessorKey: "counter_name"
      },
      {
        header: "Area",
        accessorKey: "area"
      },
       {
      header: "City",
      accessorKey: "city_name",
      Cell: ({ cell }) => cell.getValue() || "-"
    },
      {
        header: "Actions",
        Cell: ({ row }) => (
          <Flex>
            <ActionIcon
              color="green"
              onClick={() => handleEditArea(row.original)}
            >
              <IconEdit size={18}/>
            </ActionIcon>

            <ActionIcon
              ml={10}
              color="red"
              onClick={() => deleteArea(row.original.id)}
            >
              <IconTrash size={18}/>
            </ActionIcon>
          </Flex>
        )
      }
    ]}
    data={areaList}
    renderTopToolbarCustomActions={() => (
    <Box px={24} py={10}>
      <Text
        fw={600}
        tt="uppercase"
        size={"sm"}
        sx={theme => ({
          letterSpacing: 1,
          color: theme.colors.brand[7],
        })}
      >
        Area List
      </Text>
    </Box>
  )}
  />
</>

) : (

<MantineReactTable
  mantineTableProps={{ className: "datatable" }}
  enableRowActions
  positionActionsColumn="last"
  renderTopToolbarCustomActions={({ row }) => (
    <Box px={isMobileScreen ? 5 : 24} py={10}>
      <Text
        fw={600}
        tt="uppercase"
        size={"sm"}
        sx={theme => ({
          letterSpacing: 1,
          color: theme.colors.brand[7],
        })}
      >
        Counters List
      </Text>
    </Box>
  )}
  renderRowActions={({ row }) => (
    <Flex>
      <>
        {hasPermission("change_counter") && (
          <>
            <Tooltip label="Edit Counter">
              <ActionIcon
                mr={10}
                sx={theme => ({ color: theme.colors.brand[7] })}
                onClick={() => {
                  handleEdit(row.original);
                }}
              >
                <IconEdit style={{ width: 20 }} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Assign users">
              <ActionIcon
                mr={10}
                sx={theme => ({ color: theme.colors.brand[7] })}
                onClick={() => {
                  setSelectedCounter(row.original);
                  setAssignUsersModalVisible(true);
                }}
              >
                <IconUserPlus style={{ width: 20 }} />
              </ActionIcon>
            </Tooltip>
          </>
        )}

        {hasPermission("delete_counter") && (
          <Tooltip label="Delete Counter">
            <ActionIcon
              sx={theme => ({ color: theme.colors.red[7] })}
              onClick={() => {
                setSelectedCounter(row.original);
                setAssignUsersModalVisible(true);
              }}
            >
              <IconTrash style={{ width: 20 }} />
            </ActionIcon>
          </Tooltip>
        )}
      </>
    </Flex>
  )}
  initialState={{ density: "xs" }}
  state={{
    isLoading: counter_data.isLoading || counter_data.isRefetching,
  }}
  columns={columns}
  enableDensityToggle={false}
  enableFullScreenToggle={false}
  enableColumnActions={false}
  rowCount={counter_data.data?.count}
  data={countersList || []}
  enableStickyHeader
  enableGlobalFilter={false}
/>

)}

</Box>
        </Box>
      </Container>
      <Modal
  opened={areaModalVisible}
  onClose={() => setAreaModalVisible(false)}
  title="Add Area"
>

<Select
  label="Counter"
  data={countersList.map(c => ({
    value: c.id.toString(),
    label: c.name
  }))}
  value={counterId}
 onChange={(value) => {
  setCounterId(value);

  const selected = countersList.find(
    (c) => c.id.toString() === value
  );

  console.log("Selected Counter:", selected);

  if (selected) {

    // 🔥 முக்கியம்: location எடுத்துக்கணும்
    const locationValue = selected.location;

    console.log("Location:", locationValue);

    // 🔥 cityListல match பண்ணு
    const matchedCity = cityList.find(
      (c) => c.value == locationValue   // use == (string/number issue avoid)
    );

    console.log("Matched City:", matchedCity);

    if (matchedCity) {
      setCityId(matchedCity.value);
      setCityName(matchedCity.label);
    } else {
      setCityId("");
      setCityName("");
    }
  }
}}
/>

<TextInput
  mt={10}
  label="Area"
  value={area}
  onChange={e => setArea(e.target.value)}
/>

{/* ✅ CITY FIELD (READ ONLY) */}
<TextInput
  mt={10}
  label="City"
  value={cityName}
  readOnly
/>

<Button
  mt={15}
  fullWidth
  onClick={saveArea}
>
  Save
</Button>

</Modal>

      <AddCounterModal
        opened={addCounterModalVisible}
        onClose={() => {
          setAddCounterModalVisible(false);
        }}
        isEditing={isEditing}
        editData={selectedCounter}
      />

      <CounterUsersModal
        opened={assignUsersModalVisible}
        data={selectedCounter}
        onClose={() => {
          setAssignUsersModalVisible(false);
        }}
      />
      {hasPermission("add_counter") && isMobileScreen ? (
        <FloatingMenu
          m={5}
          right
          size={50}
          onClick={() => {
            setAddCounterModalVisible(true);
          }}
        >
          <IconPlus color="white" />
        </FloatingMenu>
      ) : (
        <></>
      )}
      {/* ENDS :: View order modal */}
    </>
  );
}
